<template>
    <div>
        <footer class="footer">
            <div class="container">
                <div class="row">
                    <div class="col-md-8">
                        <div class="right">
                            <div class="row">
                                <div class="col-md-6">
                                    <h3>ХОЛБОО БАРИХ</h3>
                                    <div class="footer-item">
                                        <div class="socials">
                                            <a href="" target="_blank"><i class="fa fa-twitter"></i> </a>
                                            <a href="" target="_blank"><i class="fa fa-youtube"></i> </a>
                                            <a href="" target="_blank"><i class="fa fa-facebook"></i> </a>
                                        </div>
                                        <ul class="contact-info">
                                            <li><i class="fa fa-map"></i>{{holbogdoh.hayg}}</li>
                                            <li><i class="fa fa-phone"></i>{{holbogdoh.utas_neg}}</li>
                                            <li><i class="fa fa-fax"></i>{{holbogdoh.utas_hoyor}}</li>
                                            <li><i class="fa fa-envelope"></i>{{holbogdoh.mail}}</li>
                                            <li><i class="fa fa-globe"></i>{{holbogdoh.web}}</li>
                                            <!--                                  <li><span>Вэб:</span><a href="#" target="_blank"> www.epollution.mn</a></li>-->
                                        </ul>
                                    </div>
                                </div>
                                <div class="col-md-6">
                                    <h3>ХОЛБООС</h3>
                                    <div class="row">
                                        <div class="col-6 col-md-6">
                                            <ul class="links">
                                                <li><router-link to="/mbsut">Танилцуулга</router-link></li>
                                                <li><router-link to="/news">Мэдээ мэдээлэл</router-link></li>
                                                <li><router-link to="">Чанарын баталгаажуулалт</router-link></li>
                                                <li><a href="https://info.shilendans.gov.mn/login" target="_blank">Шилэн данс</a></li>
                                                <li><router-link to="/law">Хууль эрх зүй</router-link></li>
                                            </ul>
                                        </div>
                                        <div class="col-6 col-md-6">
                                            <ul class="links">
                                                <li><router-link to="/tusgai">Тусгай зөвшөөрөл</router-link></li>

                                                <li><a >Гэрчилгээ, үнэмлэх, диплом шалгах</a></li>
                                                <li><router-link to="">Суралцагч шалгах</router-link></li>
                                                <li><router-link to="/tetgeleg">Тэтгэлэг</router-link></li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-md-4">
                        <div class="left">
                            <h3>САНАЛ ХҮСЭЛТ</h3>
                            <div class="input">
<!--                                <Input v-model="ner" placeholder="Нэр"/>-->
<!--                                <Input v-model="mail" placeholder="Цахим хаяг"/>-->
<!--                                <Input v-model="setgegdel" :rows="6" show-word-limit type="textarea" placeholder="Санал хүсэлт..."  />-->
<!--                                <div class="form-button">-->
<!--                                    <Button  @click="dataSent" class="btn btn-custom "><i class="fa fa-paper-plane-o"></i>Илгээх</Button>-->
<!--                                </div>-->
                                <Form ref="formValidate" :model="formValidate" :rules="ruleValidate">
                                    <FormItem  prop="ner">
                                        <Input v-model="formValidate.ner" placeholder="Нэр" />
                                    </FormItem>
                                    <FormItem prop="mail">
                                        <Input v-model="formValidate.mail" placeholder="И-мэйл"/>
                                    </FormItem>
                                    <FormItem  prop="setgegdel">
                                        <Input v-model="formValidate.setgegdel" type="textarea" :autosize="{minRows: 6,maxRows: 6}" placeholder="Санал хүсэлт..."/>
                                    </FormItem>
                                    <FormItem>
                                        <Button  @click="sentData('formValidate')" class="btn btn-custom "><i class="fa fa-paper-plane-o"></i>Илгээх</Button>
                                    </FormItem>
                                </Form>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="footer-bottom">
                <div class="container">
                    <div class="row">
                        <div class="col-md-12"><p class="copy">Зохиогчийн эрх хуулиар хамгаалагдсан © 2022 БШУЯ</p></div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
</template>

<script>
    import {Commetns} from "../api/index"
    export default {
        name: 'WebFooter',
        data () {
            return {
                msg: 'header',
                value: '',
                contact: {},
                saveData: {},
                // setgegdel: '',
                // ner: '',
                // mail: '',
                holbogdoh: {},
                formValidate: {
                    ner: '',
                    mail: '',
                    setgegdel: '',
                },
                ruleValidate: {
                    ner: [
                        { required: true, message: 'Нэр ээ оруулна уу !', trigger: 'blur' }
                    ],
                    mail: [
                        { required: true, message: 'И-мэйл хаяг аа оруулна уу !', trigger: 'blur' },
                        { type: 'email', message: 'И-мэйл формат буруу байна !', trigger: 'blur' }
                    ],
                    setgegdel: [
                        { required: true, message: 'Санал хүсэлт бичнэ үү !', trigger: 'blur' }
                    ],
                }
            }
        },
        methods: {
            // dataSent() {
            //     let saveData = {
            //         ner:this.ner,
            //         mail:this.mail,
            //         setgegdel:this.setgegdel,
            //     };
            //      console.log(saveData);
            //     this.$Notice.config({
            //         top: 100,
            //     });
            //     if(this.ner && this.mail && this.setgegdel) {
            //         Commetns(saveData).then((response) => {
            //             // this.ner = null;
            //             // this.mail = null;
            //             // this.setgegdel = null;
            //             // this.saveData = saveData;
            //              //this.$Notice.success({title: 'Амжилттай илгээгдлээ'});
            //             if (response.data == 'true') {
            //                 this.ner = null;
            //                 this.mail = null;
            //                 this.comments = null;
            //                 console.log(saveData);
            //                 this.saveData = saveData;
            //                 this.$Notice.success({title: 'Амжилттай илгээгдлээ'});
            //             } else {
            //                 this.$Notice.warning({title: 'Амжилтгүй '});
            //             }
            //         }).catch(() => {
            //             this.$Notice.warning({title: 'Амжилтгүй боллоо !!!'});
            //         });
            //     }else{
            //         this.$Message.error('Талбарыг гүйцэт бөглөнө үү !!!');
            //     }
            //
            // },
            sentData(name) {
                this.$Notice.config({
                    top: 150,
                });
                this.$refs[name].validate((valid) => {
                    if (valid ) {
                        if(name == 'formValidate'){
                            let saveData = {
                                ner:this.formValidate.ner,
                                mail:this.formValidate.mail,
                                setgegdel:this.formValidate.setgegdel,
                            };
                            //console.log(this.saveData);
                            Commetns(saveData).then((response)=>{
                                this.$refs[name].resetFields();
                                if(response != null){
                                    this.saveData = saveData;
                                    this.$Notice.success({title: 'Амжилттай илгээгдлээ'});
                                    //console.log(this.saveData);
                                }else {
                                    this.$Notice.warning({title: 'амжилтгүй боллоо !'});
                                }
                            })
                        }
                    } else {
                        console.log('амжилтгүй боллоо !');
                        // this.$Notice.error({title: 'Талбарыг гүйцэт бөглөнө үү !!!'});
                        return false;
                    }
                });
            },
        },
        mounted(){
            this.holbogdoh = window.init.holbogdoh;
        }
    }
</script>
